import React from 'react';
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Paper,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { motion } from 'framer-motion';

const faqs = [
  {
    category: 'Getting Started',
    questions: [
      {
        q: 'How do I get connected?',
        a: 'Check your area coverage using our coverage checker, choose a suitable package, and contact us. Our team will schedule installation within 24-48 hours.',
      },
      {
        q: 'What equipment do I need?',
        a: 'We provide all necessary equipment including a router. You just need a device (computer, phone, tablet) with Wi-Fi capability.',
      },
      {
        q: 'How long does installation take?',
        a: 'Standard installation typically takes 2-3 hours, depending on your location and setup requirements.',
      },
    ],
  },
  {
    category: 'Billing & Packages',
    questions: [
      {
        q: 'How does billing work?',
        a: 'We offer monthly billing with payments due on the 1st of each month. You can pay via M-Pesa, bank transfer, or credit card.',
      },
      {
        q: 'Can I upgrade my package?',
        a: 'Yes! You can upgrade your package at any time. The new rate will be prorated for the remainder of the billing cycle.',
      },
      {
        q: 'Is there a contract period?',
        a: 'Our standard packages come with a 12-month contract. We also offer month-to-month options at slightly higher rates.',
      },
    ],
  },
  {
    category: 'Technical Support',
    questions: [
      {
        q: 'What happens if my internet goes down?',
        a: 'Our 24/7 support team is available to help. Most issues can be resolved remotely. If needed, we\'ll send a technician within 24 hours.',
      },
      {
        q: 'How fast is the actual speed?',
        a: 'We guarantee at least 90% of the advertised speeds. You can check your speed anytime using our speed test tool.',
      },
      {
        q: 'Do you offer Wi-Fi configuration support?',
        a: 'Yes, our installation team will help set up and configure your Wi-Fi network. We also provide ongoing support for any Wi-Fi related issues.',
      },
    ],
  },
];

const FAQ = () => {
  return (
    <Container sx={{ py: 8 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Frequently Asked Questions
        </Typography>
        <Typography variant="h6" gutterBottom align="center" color="text.secondary" sx={{ mb: 6 }}>
          Find answers to common questions about our services
        </Typography>

        <Grid container spacing={4}>
          {faqs.map((category) => (
            <Grid item xs={12} key={category.category}>
              <Paper sx={{ p: 3 }}>
                <Typography variant="h5" gutterBottom color="primary">
                  {category.category}
                </Typography>
                <Box sx={{ mt: 2 }}>
                  {category.questions.map((faq, index) => (
                    <Accordion key={index}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle1" fontWeight="medium">
                          {faq.q}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography variant="body1" color="text.secondary">
                          {faq.a}
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Typography variant="h6" gutterBottom>
            Still have questions?
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Contact our support team 24/7 at support@devolvedtelco.co.ke or call 0716 504 441
          </Typography>
        </Box>
      </motion.div>
    </Container>
  );
};

export default FAQ;
